import React from "react";
import InputDate from "../../../../components/inputs/date/inputDate";
import { DayliPlanContext } from "../context/dayliPlanContext";
import IDayliPlan from "../interface/iDayliPlan";

const FromDateInput = (): React.JSX.Element => {
  const {
    isLoading,
    dayliPlan,
    setDayliPlan,
  }: {
    isLoading: boolean;
    dayliPlan: IDayliPlan;
    setDayliPlan: (dayliPlan: IDayliPlan) => void;
  } = React.useContext(DayliPlanContext);

  const onChangeHandler = (date: string): void =>
    setDayliPlan({ ...dayliPlan, fromDate: date });

  return (
    <InputDate
      label="Von"
      disabled={isLoading}
      date={dayliPlan.fromDate}
      setDate={onChangeHandler}
    />
  );
};

export default FromDateInput;
